var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"btn",class:[_vm.type, _vm.size],attrs:{"to":_vm.to,"tag":"button","title":_vm.title}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.label))}}),(_vm.icon)?_c('span',{staticClass:"glyphicon marginal-left-m",class:[_vm.icon]}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }